import { render, staticRenderFns } from "./ChangePasswordBtn.vue?vue&type=template&id=683a6c1c"
import script from "./ChangePasswordBtn.vue?vue&type=script&lang=js"
export * from "./ChangePasswordBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports